import { UserInfo } from '@faro/user-management-model';
import type { AppName, AppPermissions } from './AppPermissions';

const appNameByRole = new Map<string, AppName[]>([
    ['STUDY-DEFINITION-ADMIN', ['protocol-optimization']],
    ['EDITOR', ['study-designer', 'study-spaces', 'study-reporting', 'protocol-import']],
    ['VIEWER', ['study-designer', 'study-spaces', 'study-reporting', 'protocol-import']],
    ['DYNAMIC-FIELD-DEF-ADMIN', ['content-library']],
    ['SNIPPET-ADMIN', ['content-library']],
    ['DOCUMENT-TEMPLATE-ADMIN', ['content-library']],
    ['USER-ADMIN', ['user-management']],
]);

export function getAppPermissions(user: UserInfo): AppPermissions {
    const grantedApps = (user.roles || []).reduce((grantedApps: Set<AppName>, role: string) => {
        const appNames = appNameByRole.get(role);
        appNames?.forEach(appName => {
            grantedApps.add(appName);
        });
        return grantedApps;
    }, new Set<AppName>([]));

    return { grantedApps };
}
